import * as React from 'react';

import {List} from '@common/typescript/objects/List';

import FaqBlock from '@app/components/UI/FaqBlock/FaqBlock';
import {ResourceTopic} from '@app/objects/ResourceTopic';
import {Issues, Questions} from '@app/objects/Questions';
import {rest} from '@app/components/Api';
import withSeo from '@app/components/LocalCommon/HigherOrderComponents/WithSeo';

const FRFaq = (props) => {

	const {match, categoriesFAQ, setCategoriesFAQ, currentCategoryFAQ, setCurrentCategoryFAQ, searchQuery} = props;
	const [questions, setQuestions] = React.useState<Questions[]>([]);
	const [isLoaded, setIsLoaded] = React.useState<boolean>(false);

	const fetchAll = () => {
		setQuestions([]);
		Promise.all(
			categoriesFAQ.map((category) => {
				return rest.get<List<Questions>>(`v1/faq/${category.name}?text=${searchQuery}`)
					.then((res) => {
						return res.list;
					});
			})
		).then((res) => {
			const empty = [] as Questions[];
			const queriedQuestions = empty.concat.apply([], res as Questions[]);
			setQuestions(queriedQuestions);
		});
	};

	React.useEffect(() => {
		!searchQuery ? rest.get<List<Issues>>('v1/faqCategories/').then(res => setCategoriesFAQ(res.list)) :
			fetchAll();

	}, [searchQuery]);

	React.useEffect(() => {
		if (currentCategoryFAQ?.name) {
			rest.get<List<Questions>>(`v1/faq/${currentCategoryFAQ.name}${searchQuery ? `?text=${searchQuery}` : ''}`)
				.then((res) => {
					setQuestions(res.list);
					setIsLoaded(true);
				});
		} else  {
			searchQuery ? fetchAll() : null;
		}
	}, [currentCategoryFAQ, searchQuery]);

	const showCategory = (category) => {
		setCurrentCategoryFAQ(category);
		window.scrollTo(0, 0);
		document.querySelector('#react-app')?.scrollTo(0, 0);
	};

	return (
		<section className="faq-block faq-page">
			<div className="faq-block-body">
				{!searchQuery ?
					<div className="faq-block-content">
						{/*--------------certain FAQ category--------------*/}
						{currentCategoryFAQ && currentCategoryFAQ.name && (
							<>
								<header className="faq-block-header">
									{currentCategoryFAQ.name}
								</header>
								{questions.length ?
										<FaqBlock
											questions={questions} carrotIcon={require('@app/images/carrot_dark.svg')}
										/>
									:
									!isLoaded ? <div className="faq-block__dummy">Woof! Looks like we're still loading a few things.</div> :
									<div className="faq-block__dummy">Woof! We were not able to find a match. Please try another search.</div>
								}
							</>
						)}
						{/*--------------all FAQ categories--------------*/}
						{!(currentCategoryFAQ && currentCategoryFAQ.name) && categoriesFAQ.length &&
						categoriesFAQ.map((item, index) => (
							<React.Fragment key={`category-${item.name}-${index}`}>
								<header key={`faq-header-${index}`} className="faq-block-header">
									{item.name}
								</header>
								{item.questions ?
									<FaqBlock
										key={item.name + index}
										questions={item.questions}
										carrotIcon={require('@app/images/carrot_dark.svg')}
										maxCount={3}
										linkCategory={`/faq/${item.name.toLowerCase().replace(/[&]/g, 'and').replace(/\s+/g, '-')}`}
										category={item}
										showCategory={showCategory}
									/>
									:
									<div className="faq-block__dummy">Woof! We were not able to find a match. Please try another search.</div>
								}
							</React.Fragment>
						))
						}

					</div>
					:
						questions.length ?
						<FaqBlock questions={questions} carrotIcon={require('@app/images/carrot_dark.svg')}/>
						:
							<div className="faq-block__dummy">Woof! We were not able to find a match. Please try another search.</div>
				}
			</div>
		</section>
	);
};

export default withSeo(FRFaq, state => state.faqPage, 'faqPage', 'faq');